import React, { useEffect } from 'react'
import styled from 'styled-components'
import { CollaboInviteCard } from 'src/components/Global/Cards/Cards'
import { CollaboInviteText } from 'src/components/Global/Text/TitleText'
import {
  CollaboAcceptButton,
  CollaboDeclineButton,
} from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { NoCollabo } from './NoCollabo'
import { useTypedSelector } from 'src/redux/root-reducer'
import {
  getAllCollaboInvitesAction,
  rejectCollaboInvitetAction,
} from 'src/redux/actions/collaboAction'

import { addNairaSign } from 'src/utils/addNairaSign'
import useUserData from 'src/hooks/useUserData'
import { useDispatch } from 'react-redux'

const PATH: any = []

const CollaboInvite = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCollaboInvitesAction())
    // getAllPaths()
  }, [dispatch])
  const USER_DATA = useUserData()
  let location = useLocation()

  const allInvites = useTypedSelector((state) => state.collabo.invites)
  const rejectCollabo = (id: any, e: any) => {
    e.preventDefault()
    dispatch(rejectCollaboInvitetAction(id))
  }
  return (
    <CollaboInviteWrapper>
      {allInvites.length > 0 ? (
        <div>
          {allInvites.map((item: any) => (
            <CollaboInviteCard key={item.id}>
              <div className="heading">
                <div className="profile">
                  <img
                    src={item.collabo.image_url}
                    alt=""
                    className="pic-width"
                  />
                  <div className="info">
                    <h2>{item.collabo.created_by}</h2>
                    <p className="email">{` Collabo Amount: ${addNairaSign(
                      item.collabo.target
                    )}`}</p>
                  </div>
                </div>
                <div>
                  <p className="time">{`${item.collabo.number_of_members} ${
                    item.collabo.number_of_members === 1 ? 'member' : 'members'
                  }`}</p>
                </div>
              </div>
              <CollaboInviteText>{item.collabo.group_name}</CollaboInviteText>
              <p className="desc">
                {`Hello ${USER_DATA.user.first_name} ,  ${item.collabo.created_by} has just invited you
                to their collabo plan`}
                <span> {item.collabo.group_name}</span>
              </p>
              <div className="buttons">
                <Link
                  to={`/AcceptCollabo/${item.id}`}
                  state={{ backgroundLocation: location }}
                >
                  <CollaboAcceptButton>Accept</CollaboAcceptButton>
                </Link>
                <CollaboDeclineButton
                  onClick={(e: any) => rejectCollabo(item.id, e)}
                >
                  Decline
                </CollaboDeclineButton>
              </div>
            </CollaboInviteCard>
          ))}
        </div>
      ) : (
        <NoCollabo>You have no collabo invites yet</NoCollabo>
      )}
    </CollaboInviteWrapper>
  )
}
function getCustomModalsCollaboPathId(id: any) {
  return PATH.find((image: any) => image.id === id)
}
export { CollaboInvite, getCustomModalsCollaboPathId }

const CollaboInviteWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .buttons {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .pic-width {
    width: 40px;
    height: 40px;
  }
  .heading {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
  }
  .profile {
    display: flex;
    align-items: center;
  }
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    text-transform: uppercase;
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSize.x2};
    color: ${({ theme }) => theme.colors.dark};
  }
  .email {
    font-size: ${({ theme }) => theme.fontSize.x3};
    color: ${({ theme }) => theme.colors.gray};
    margin-top: -10px;
  }
  .time {
    font-size: ${({ theme }) => theme.fontSize.x2};
    color: ${({ theme }) => theme.colors.gray};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: none;
    }
  }
  .desc {
    font-size: ${({ theme }) => theme.fontSize.x8};
    color: ${({ theme }) => theme.colors.dark};
    line-height: 18px;
    margin-top: 12px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x4};
    }
  }
  span {
    font-weight: bold;
  }
  .info {
    padding-left: 17px;
  }
`
